import { useTranslation } from 'react-i18next';
import { Icon } from '../../components/Icon';
import type { UnsavedDraft } from '../../hooks/unsavedDraftStore';

/** #1165 layer 2: offers back the unsaved work kept on this device -- Restore or Discard. */
export function UnsavedDraftBanner({
  draft,
  onRestore,
  onDiscard
}: {
  readonly draft: UnsavedDraft;
  readonly onRestore: () => void;
  readonly onDiscard: () => void;
}) {
  const { t, i18n } = useTranslation();
  const kept = new Date(draft.keptAt);
  const today = kept.toDateString() === new Date().toDateString();
  const time = new Intl.DateTimeFormat(
    i18n.language,
    today ? { timeStyle: 'short' } : { dateStyle: 'medium', timeStyle: 'short' }
  ).format(kept);
  const title = draft.title.trim();
  return (
    <div
      className="workspace-draft-banner"
      role="region"
      aria-label={t('unsavedDraft.label')}
      data-testid="unsaved-draft-banner"
    >
      <p>{title ? t('unsavedDraft.offerTitled', { title, time }) : t('unsavedDraft.offer', { time })}</p>
      <button type="button" className="workspace-draft-banner-restore" onClick={onRestore}>
        <Icon name="undo" size="1.1rem" />
        <span>{t('unsavedDraft.restore')}</span>
      </button>
      <button type="button" onClick={onDiscard}>
        <Icon name="delete" size="1.1rem" />
        <span>{t('unsavedDraft.discard')}</span>
      </button>
    </div>
  );
}
